import { render } from "./FormNumberSinester.vue?vue&type=template&id=2addd345"
import script from "./FormNumberSinester.vue?vue&type=script&lang=js"
export * from "./FormNumberSinester.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__